import _regeneratorRuntime from "/var/app/current/WebApp/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/app/current/WebApp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/var/app/current/WebApp/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/var/app/current/WebApp/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/app/current/WebApp/node_modules/@babel/runtime/helpers/esm/createClass";
// Support regenerator-runtime globally.
import "regenerator-runtime/runtime.js";
import Base64 from "./core/base64.js";
import Converter from "./core/converter.js";
import File from "./core/file.js";
import Image from "./core/image.js";
import Photo from "./core/photo.js";
import Rotate from "./core/rotate.js"; // Supported input formats
// image/png, image/jpeg, image/jpg, image/gif, image/bmp, image/tiff, image/x-icon,  image/svg+xml, image/webp, image/xxx
// image/png, image/jpeg, image/webp

var Compress = /*#__PURE__*/function () {
  function Compress() {
    _classCallCheck(this, Compress);
  }

  _createClass(Compress, [{
    key: "attach",
    value: function attach(el, options) {
      var _this = this;

      return new Promise(function (resolve) {
        var input = document.querySelector(el);
        input.setAttribute("accept", "image/*");
        input.addEventListener("change", function (evt) {
          var output = _this.compress(_toConsumableArray(evt.target.files), options);

          resolve(output);
        }, false);
      });
    }
  }, {
    key: "compress",
    value: function compress(files, options) {
      return Promise.all(files.map(function (file) {
        return compressFile(file, options);
      }));
    }
  }], [{
    key: "convertBase64ToFile",
    value: function convertBase64ToFile(base64, mime) {
      return Converter.base64ToFile(base64, mime);
    }
  }]);

  return Compress;
}();

export { Compress as default };

function loopCompression(canvas, size) {
  var quality = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var targetSize = arguments.length > 3 ? arguments[3] : undefined;
  var targetQuality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var iterations = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
  var base64str = Converter.canvasToBase64(canvas, quality);
  var newSize = Base64.size(base64str);
  return newSize > targetSize || quality > targetQuality ? loopCompression(canvas, newSize, quality - 0.1, targetSize, targetQuality, iterations + 1) : base64str;
}

function compressFile(_x, _x2) {
  return _compressFile.apply(this, arguments);
}

function _compressFile() {
  _compressFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file, options) {
    var photo;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // Create a new photo object
            photo = new Photo(options);
            photo.start = window.performance.now();
            photo.alt = file.name;
            photo.ext = file.type;
            photo.startSize = file.size;

            if (!photo.rotate) {
              _context2.next = 11;
              break;
            }

            _context2.next = 8;
            return Rotate.orientation(file);

          case 8:
            _context2.t0 = _context2.sent;
            _context2.next = 12;
            break;

          case 11:
            _context2.t0 = 0;

          case 12:
            photo.orientation = _context2.t0;
            _context2.t1 = compressImage(photo);
            _context2.next = 16;
            return File.load(file);

          case 16:
            _context2.t2 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t1)(_context2.t2));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _compressFile.apply(this, arguments);
}

function compressImage(photo) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src) {
      var img, _Image$resize, width, height, canvas, base64, difference;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Image.load(src);

            case 2:
              img = _context.sent;
              // Store the initial dimensions
              photo.startWidth = img.naturalWidth;
              photo.startHeight = img.naturalHeight; // Resize the image

              if (photo.resize) {
                _Image$resize = Image.resize(photo.maxWidth, photo.maxHeight)(img.naturalWidth, img.naturalHeight), width = _Image$resize.width, height = _Image$resize.height;
                photo.endWidth = width;
                photo.endHeight = height;
              } else {
                photo.endWidth = img.naturalWidth;
                photo.endHeight = img.naturalHeight;
              }

              canvas = Converter.imageToCanvas(photo.endWidth, photo.endHeight, photo.orientation)(img);
              photo.iterations = 1;
              photo.base64prefix = Base64.prefix(photo.ext);
              _context.next = 11;
              return loopCompression(canvas, photo.startSize, photo.quality, photo.size, photo.minQuality, photo.iterations);

            case 11:
              base64 = _context.sent;
              photo.finalSize = Base64.size(base64);
              photo.end = window.performance.now();
              difference = photo.end - photo.start; // in ms

              return _context.abrupt("return", {
                data: Base64.data(base64),
                prefix: photo.base64prefix,
                elapsedTimeInSeconds: difference / 1000,
                // in seconds
                alt: photo.alt,
                initialSizeInMb: Converter.size(photo.startSize).MB,
                endSizeInMb: Converter.size(photo.finalSize).MB,
                ext: photo.ext,
                quality: photo.quality,
                endWidthInPx: photo.endWidth,
                endHeightInPx: photo.endHeight,
                initialWidthInPx: photo.startWidth,
                initialHeightInPx: photo.startHeight,
                sizeReducedInPercent: (photo.startSize - photo.finalSize) / photo.startSize * 100,
                iterations: photo.iterations
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
}